// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Roles & permissions. Root: .roles-page */
.roles-page__title {
  margin: 0 0 var(--ds-space-3);
  font-size: var(--ds-title-size);
}

.roles-page__matrix {
  margin-top: var(--ds-space-4);
}

.roles-page__perm-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--ds-space-2) var(--ds-space-4);
}

.roles-page .roles-page__perm-group {
  display: flex;
  flex-wrap: wrap;
  gap: var(--ds-space-1) var(--ds-space-3);
}

.roles-page__grant-all {
  display: flex;
  align-items: center;
  min-height: var(--ds-touch);
  margin-bottom: var(--ds-space-3);
  padding-inline: var(--ds-space-3);
  background: var(--ds-surface);
  border: 1px solid var(--ds-border-soft);
  border-radius: var(--ds-radius-md);
}

.roles-page__cards {
  display: grid;
  gap: var(--ds-space-3);
  margin: 0;
  padding: 0;
  list-style: none;
}

/* Phones: each permission gets its own full-height touch row. */
.roles-page .roles-page__card .roles-page__perm-group {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0 var(--ds-space-2);
}

.roles-page .roles-page__card .roles-page__perm-group .ant-checkbox-wrapper,
.roles-page .roles-page__grant-all .ant-checkbox-wrapper,
.roles-page .roles-page__card .ant-card-extra .ant-checkbox-wrapper {
  min-height: 40px;
  align-items: center;
  margin-inline-end: 0;
}

.roles-page .roles-page__card .ant-card-head-title {
  white-space: normal;
  overflow-wrap: anywhere;
}

.roles-page__save {
  display: flex;
  justify-content: flex-end;
  margin-top: var(--ds-space-5);
}

@media (max-width: 767.98px) {
  /* Save stays reachable while scrolling through the module cards. */
  .roles-page__save {
    position: sticky;
    bottom: 0;
    z-index: 2;
    margin-inline: calc(-1 * var(--ds-page-pad));
    padding: var(--ds-space-3) var(--ds-page-pad);
    background: var(--ds-surface);
    border-top: 1px solid var(--ds-border-soft);
    box-shadow: var(--ds-shadow-sm);
  }

  .roles-page__save .ant-btn {
    flex: 1 1 auto;
  }

  /* The fixed bottom navigation covers the bottom of the scroll area. */
  .app-shell--with-bottomnav .roles-page__save {
    bottom: calc(var(--ds-bottomnav-h) + var(--ds-safe-bottom));
  }
}
`, "",{"version":3,"sources":["webpack://./src/serviceProvider/components/rolesAndPermissions/RolesManagement.css"],"names":[],"mappings":"AAAA,2CAA2C;AAC3C;EACE,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,gCAAgC;EAChC,iCAAiC;EACjC,6BAA6B;EAC7B,uCAAuC;EACvC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA,gEAAgE;AAChE;EACE,aAAa;EACb,gDAAgD;EAChD,wBAAwB;AAC1B;;AAEA;;;EAGE,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,mEAAmE;EACnE;IACE,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,4CAA4C;IAC5C,6CAA6C;IAC7C,6BAA6B;IAC7B,2CAA2C;IAC3C,+BAA+B;EACjC;;EAEA;IACE,cAAc;EAChB;;EAEA,sEAAsE;EACtE;IACE,2DAA2D;EAC7D;AACF","sourcesContent":["/* Roles & permissions. Root: .roles-page */\n.roles-page__title {\n  margin: 0 0 var(--ds-space-3);\n  font-size: var(--ds-title-size);\n}\n\n.roles-page__matrix {\n  margin-top: var(--ds-space-4);\n}\n\n.roles-page__perm-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: var(--ds-space-2) var(--ds-space-4);\n}\n\n.roles-page .roles-page__perm-group {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--ds-space-1) var(--ds-space-3);\n}\n\n.roles-page__grant-all {\n  display: flex;\n  align-items: center;\n  min-height: var(--ds-touch);\n  margin-bottom: var(--ds-space-3);\n  padding-inline: var(--ds-space-3);\n  background: var(--ds-surface);\n  border: 1px solid var(--ds-border-soft);\n  border-radius: var(--ds-radius-md);\n}\n\n.roles-page__cards {\n  display: grid;\n  gap: var(--ds-space-3);\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n/* Phones: each permission gets its own full-height touch row. */\n.roles-page .roles-page__card .roles-page__perm-group {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0 var(--ds-space-2);\n}\n\n.roles-page .roles-page__card .roles-page__perm-group .ant-checkbox-wrapper,\n.roles-page .roles-page__grant-all .ant-checkbox-wrapper,\n.roles-page .roles-page__card .ant-card-extra .ant-checkbox-wrapper {\n  min-height: 40px;\n  align-items: center;\n  margin-inline-end: 0;\n}\n\n.roles-page .roles-page__card .ant-card-head-title {\n  white-space: normal;\n  overflow-wrap: anywhere;\n}\n\n.roles-page__save {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: var(--ds-space-5);\n}\n\n@media (max-width: 767.98px) {\n  /* Save stays reachable while scrolling through the module cards. */\n  .roles-page__save {\n    position: sticky;\n    bottom: 0;\n    z-index: 2;\n    margin-inline: calc(-1 * var(--ds-page-pad));\n    padding: var(--ds-space-3) var(--ds-page-pad);\n    background: var(--ds-surface);\n    border-top: 1px solid var(--ds-border-soft);\n    box-shadow: var(--ds-shadow-sm);\n  }\n\n  .roles-page__save .ant-btn {\n    flex: 1 1 auto;\n  }\n\n  /* The fixed bottom navigation covers the bottom of the scroll area. */\n  .app-shell--with-bottomnav .roles-page__save {\n    bottom: calc(var(--ds-bottomnav-h) + var(--ds-safe-bottom));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
